import { createContext } from "react";

export const FunctionContext = createContext<{
  [key: string]: any;
}>({});
